export default {
  Shopping_Cart_Clicked_Remove_Btn: 'Shopping_Cart_Clicked_Remove_Btn',
  Shopping_Cart_Clicked_Checkout_Btn: 'Shopping_Cart_Clicked_Checkout_Btn',
  Shopping_Cart_Clicked_Continue_Shopping_Btn: 'Shopping_Cart_Clicked_Continue_Shopping_Btn',
  Add_To_Cart_Modal_Clicked_Keep_Shopping_Btn: 'Add_To_Cart_Modal_Clicked_Keep_Shopping_Btn',
  Shopping_Cart_Clicked_Other_Popular_Item: 'Shopping_Cart_Clicked_Other_Popular_Item'
}
